import { useCallback, useState } from 'react';

/** @graph-connects none */
export function useSeriesToggle() {
  const [hiddenSeries, setHiddenSeries] = useState<Set<string>>(new Set());

  const handleLegendClick = useCallback((entry: { dataKey?: unknown }) => {
    const key = entry.dataKey;
    if (typeof key !== 'string') return;
    setHiddenSeries((prev) => {
      const next = new Set(prev);
      if (next.has(key)) {
        next.delete(key);
      } else {
        next.add(key);
      }
      return next;
    });
  }, []);

  const resetHidden = useCallback(() => {
    setHiddenSeries(new Set());
  }, []);

  return { hiddenSeries, handleLegendClick, resetHidden } as const;
}
